import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { Mbp3Service } from 'src/app/services/mbp3.service';

@Component({
  selector: 'app-mbp3',
  templateUrl: './mbp3.component.html',
  styleUrls: ['./mbp3.component.css']
})
export class Mbp3Component implements OnInit {

  mbp3Form: FormGroup;
  mbp3List: any[];
  dateOfBoardResolutionModel: any;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  addBtn: boolean;
  particularId: any;
  dateOfInvestmentModel: { month: number; day: number; year: number; };
  dateofdisposalModel: { month: number; day: number; year: number; };
  editParticularData: any;
  disabledOnClick: boolean;

  constructor(private mbp3Service: Mbp3Service, private activatedRoute: ActivatedRoute, 
    private alert: AlertComponent,private router: Router) { }

  ngOnInit() {

    this.mbp3Form = new FormGroup({
      dateOfBoardResolution: new FormControl('', [Validators.required]),
      dateOfInvestment: new FormControl('', []),
      investmentHeldBy: new FormControl('', [Validators.required]),
      typeOfInvestment: new FormControl('', []),
      nameOfThePersonInvestment: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .',&-]*$"), Validators.maxLength(50)]),
      // nameofdepositoryinvestment: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .',&-]*$"), Validators.maxLength(50)]),
      addressOfPerson: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .',&/-]*$"), Validators.maxLength(150)]),
      emailOfPerson: new FormControl('', [Validators.pattern("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"), Validators.maxLength(30)]),
      purposeOfInvestment: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .',&-]*$"), Validators.maxLength(250)]),
      nameOfCompany: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .',&-]*$"), Validators.maxLength(100)]),
      classOfSecurities: new FormControl('', [Validators.pattern("^[a-zA-Z .,]*$"), Validators.maxLength(50)]),
      numberOfSecurities: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(10)]),
      clientId: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .',/-]*$"), Validators.maxLength(16)]),
      faceValueOfSecurities: new FormControl('', [Validators.pattern("^[0-9 ,.' /-]*$"), Validators.maxLength(5)]),
      paidUpValueOfSecurities: new FormControl('', [Validators.pattern("^[0-9 ,.' /-]*$"), Validators.maxLength(20)]),
      costOfAcquistion: new FormControl('', [Validators.pattern("^[0-9 ,.' /-]*$"), Validators.maxLength(20)]),
      dateofdisposal: new FormControl('', []),
      numberOfSecuritiesDisposedOff: new FormControl('', [Validators.pattern("^[0-9 ,.' /-]*$"), Validators.maxLength(10)]),
      saleConsideration: new FormControl('', [Validators.pattern("^[0-9 ,.' /-]*$"), Validators.maxLength(20)]),
      balanceSecuritiesLeft: new FormControl('', [Validators.pattern("^[0-9 ,.' /-]*$"), Validators.maxLength(20)]),
      theRelationshipContract: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,.' /-]*$"), Validators.maxLength(250)]),
      reasonsForNotHolding: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,\n .' /-]*$"), Validators.maxLength(2000)]),
      remarks: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,\n.' /-]*$"), Validators.maxLength(2000)])
    })


    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.addBtn = false;
        this.particularId = params['particularId'];
        this.getMbpById(this.particularId);
      } else {
        this.addBtn = true;
      }
      console.log("addBtn",this.addBtn)
    })
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp3List']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;

    }
    return null;
  }

  saveMbp3Data(flag) {
    this.disabledOnClick = true;
    var object = {
      dateOfBoardResolution: this.setDate(this.mbp3Form.controls.dateOfBoardResolution.value),
      dateOfInvestment: this.setDate(this.mbp3Form.controls.dateOfInvestment.value),
      investmentHeldBy: this.mbp3Form.controls.investmentHeldBy.value,
      typeOfInvestment: this.mbp3Form.controls.typeOfInvestment.value,
      nameOfThePersonInvestment: this.mbp3Form.controls.nameOfThePersonInvestment.value,
      // nameofdepositoryinvestment: this.mbp3Form.controls.nameofdepositoryinvestment.value,
      addressOfPerson: this.mbp3Form.controls.addressOfPerson.value,
      emailOfPerson: this.mbp3Form.controls.emailOfPerson.value,
      purposeOfInvestment: this.mbp3Form.controls.purposeOfInvestment.value,
      nameOfCompany: this.mbp3Form.controls.nameOfCompany.value,
      classOfSecurities: this.mbp3Form.controls.classOfSecurities.value,
      numberOfSecurities: this.mbp3Form.controls.numberOfSecurities.value,
      clientId: this.mbp3Form.controls.clientId.value,
      faceValueOfSecurities: this.mbp3Form.controls.faceValueOfSecurities.value,
      paidUpValueOfSecurities: this.mbp3Form.controls.paidUpValueOfSecurities.value,
      costOfAcquistion: this.mbp3Form.controls.costOfAcquistion.value,
      dateofdisposal: this.setDate(this.mbp3Form.controls.dateofdisposal.value),
      numberOfSecuritiesDisposedOff: this.mbp3Form.controls.numberOfSecuritiesDisposedOff.value,
      saleConsideration: this.mbp3Form.controls.saleConsideration.value,
      balanceSecuritiesLeft: this.mbp3Form.controls.balanceSecuritiesLeft.value,
      theRelationshipContract: this.mbp3Form.controls.theRelationshipContract.value,
      reasonsForNotHolding: this.mbp3Form.controls.reasonsForNotHolding.value,
      remarks: this.mbp3Form.controls.remarks.value,

    }
    console.log("object ", object);
    console.log("form ", this.mbp3Form);
    if (flag == 'add') {
      this.mbp3Service.addMbpData(object).subscribe(response => {
        console.log("response", response);
        this.disabledOnClick = false;
        if (response.status == 0) {
          this.alert.successWithOk(response.message, 'mbp3List');
        } else {
          // this.alert.error(response.message);
          if(response.err_fields){
          this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
          }
          else{
            this.alert.error(response.message);
          }
        }
      })
    } else if (flag == 'update') {
      this.mbp3Service.updateMbpData(this.particularId, object).subscribe(response => {
        this.disabledOnClick = false;
        if (response.status == 0) {
          this.alert.successWithOk(response.message, 'mbp3List');
        } else {
          if(response.err_fields){
            this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
            }
            else{
              this.alert.error(response.message);
            }
        }
      })
    }
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  getMbpById(id) {

    this.mbp3Service.getMbpById(id).subscribe(response => {
      console.log("response",response);
      this.editParticularData = response.data[0];
      this.mbp3Form.controls.investmentHeldBy.setValue(this.editParticularData.investmentHeldBy);
      this.mbp3Form.controls.typeOfInvestment.setValue(this.editParticularData.typeOfInvestment);
      this.mbp3Form.controls.nameOfThePersonInvestment.setValue(this.editParticularData.nameOfThePersonInvestment);
      // this.mbp3Form.controls.nameofdepositoryinvestment.setValue(this.editParticularData.nameofdepositoryinvestment);
      this.mbp3Form.controls.addressOfPerson.setValue(this.editParticularData.addressOfPerson);
      this.mbp3Form.controls.emailOfPerson.setValue(this.editParticularData.emailOfPerson);
      this.mbp3Form.controls.purposeOfInvestment.setValue(this.editParticularData.purposeOfInvestment);
      this.mbp3Form.controls.nameOfCompany.setValue(this.editParticularData.nameOfCompany);
      this.mbp3Form.controls.classOfSecurities.setValue(this.editParticularData.classOfSecurities);
      this.mbp3Form.controls.numberOfSecurities.setValue(this.editParticularData.numberOfSecurities);
      this.mbp3Form.controls.clientId.setValue(this.editParticularData.clientId);
      this.mbp3Form.controls.faceValueOfSecurities.setValue(this.editParticularData.faceValueOfSecurities);
      this.mbp3Form.controls.paidUpValueOfSecurities.setValue(this.editParticularData.paidUpValueOfSecurities);
      this.mbp3Form.controls.costOfAcquistion.setValue(this.editParticularData.costOfAcquistion);
      this.mbp3Form.controls.numberOfSecuritiesDisposedOff.setValue(this.editParticularData.numberOfSecuritiesDisposedOff);
      this.mbp3Form.controls.saleConsideration.setValue(this.editParticularData.saleConsideration);
      this.mbp3Form.controls.balanceSecuritiesLeft.setValue(this.editParticularData.balanceSecuritiesLeft);
      this.mbp3Form.controls.theRelationshipContract.setValue(this.editParticularData.theRelationshipContract);
      this.mbp3Form.controls.reasonsForNotHolding.setValue(this.editParticularData.reasonsForNotHolding);
      this.mbp3Form.controls.remarks.setValue(this.editParticularData.remarks);

      if (this.editParticularData.dateOfBoardResolution != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfBoardResolution));
        this.dateOfBoardResolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOfInvestment != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfInvestment));
        this.dateOfInvestmentModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateofdisposal != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateofdisposal));
        this.dateofdisposalModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
    })
  }
  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  generateOutput() {
    var object = {
      id: this.particularId,
      fromDate: null,
      toDate: null,
      name: null,
      param1: null,
      date1: null
    }
    this.mbp3Service.generateMbp3Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.particularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.particularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mbp3Service.downloadMbp3File(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.mbp3Service.downloadMbp3PdfFile(id, 'Single');
  }

}
